export default "__VITE_ASSET__5122e5c8__"